import { render, staticRenderFns } from "./game-setting.vue?vue&type=template&id=4952b1ea&scoped=true&"
import script from "./game-setting.vue?vue&type=script&lang=js&"
export * from "./game-setting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4952b1ea",
  null
  
)

export default component.exports